import Navbar from "../components/Navbar";
import SecondNavbar from "../components/SecondNavbar";
import Footer from "../components/Footer";
import ProtectedWrapper from "../components/ProtectedWrapper";
import CreateCampaignContent from "./CreateCampaignContent"; // sirf form wala component

const CreateCampaign = () => {
  return (
    <>
      <Navbar />
      <SecondNavbar />

      <ProtectedWrapper isLoggedIn={!!localStorage.getItem("token")}>
        <CreateCampaignContent />
      </ProtectedWrapper>

      <Footer />
    </>
  );
};

export default CreateCampaign;